export default __webpack_public_path__ + "static/media/logoM.f9572545.svg";